import { CatalogueType } from '@/config/types'

const seasons: Record<string, CatalogueType> = {
  SZ: 'summer',
  WG: 'winter',
  BZ: 'summer',
  BW: 'winter',
  FS: 'summer',
  FH: 'winter',
  FZ: 'summer',
  FW: 'winter',
  DW: 'winter',
  UW: 'winter',
  QZ: 'summer',
  QW: 'winter',
  KZ: 'summer',
  KW: 'winter',
}

export function getSeason(publicationCode: string): CatalogueType {
  return seasons[publicationCode]
}
